
import React from 'react';
import Layout from '@/components/Layout/Layout';
import DataTransferRateConverter from '@/components/UnitConverter/DataTransferRateConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const DataTransferRateConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2 font-bold">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Data Transfer Rate Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different data transfer rate units, from bits per second to gigabytes per second.
          </p>
        </div>
        
        <div className="mb-8">
          <DataTransferRateConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Data Transfer Rate Converter</h2>
          <p>
            Our data transfer rate converter tool will help you convert between different units used to measure
            the speed of data transfer in computing and networking. Whether you're comparing internet connection speeds,
            network throughput, or file transfer rates, this converter will provide accurate conversions between bits per second,
            kilobits per second, megabits per second, and more.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Coming Soon</h3>
          <p>
            We're currently developing this feature to support a comprehensive range of data transfer rate units.
            Check back soon for the complete functionality!
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default DataTransferRateConverterPage;
